import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./pages/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Confession from "./pages/Confession";
import Footer from "./pages/Footer";
import Create from "./pages/Create";
import Help from "./pages/Help";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
    return (
        <div className="App bg-slate-900  bg-gradient-home">
            <Router>
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/confession" element={<Confession />} />
                    <Route path="/create" element={<Create />} />
                    <Route path="/help" element={<Help />} />
                    <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                </Routes>
                <Footer />
            </Router>
        </div>
    );
}

export default App;
